import AccountAiAssignmentsContent from '@UI/Pages/AiAssignments/AccountAiAssignments/AccountAiAssignmentsContent';
import AiAssignmentsNotifications from '@UI/Pages/AiAssignments/Shared/AiAssignmentsNotifications';
import LevelSwitch from '@Guidelines/Component/LevelSwitch';
import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import useAccessibleNavigationLevels from '@UI/Hooks/useAccessibleNavigationLevels';
import type * as React from 'react';

/**
 * Assembles the screen: header, the data-owning `AccountAiAssignmentsContent`, and the notifications
 * shared by the three affectation screens. No sidebar, no confirmation dialog: assigning or reverting
 * a model happens inline, from `UsageAssignmentCardActions`' own dropdown and `ConfirmDialog`.
 */
const AccountAiAssignmentsPage: React.FC = () => {
	const levels = useAccessibleNavigationLevels('ai-models');

	return (
		<PageContainer>
			<PageHeader
				eyebrow="CONFIGURATION"
				title="Modèles du compte"
				description="Affectez un modèle à chaque usage pour l’ensemble du compte : le point de départ de la cascade, surchargeable par structure puis par agence."
				actions={<LevelSwitch ariaLabel="Niveau des modèles d'IA" levels={levels} />}
			/>
			<AccountAiAssignmentsContent />
			<AiAssignmentsNotifications />
		</PageContainer>
	);
};

export default AccountAiAssignmentsPage;
